<template>
  <!-- Add Ban -->
  <div class="modal fade" id="ban-address">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add New Ban IP Address</h5>
          <button type="button" class="close" data-bs-dismiss="modal" :aria-label="$t('close')">
            <span class="material-icons">close</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="user-profiles-group mb-4">
            <form>
              <div class="row">
                <div class="col-md-12">
                  <div class="pass-login">
                    <label class="form-label">IP Address</label>
                    <input type="text" class="form-control" />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="pass-login">
                    <label class="form-label">Reason For Ban</label>

                    <editor v-model="content" />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="status-logs">
                    <h6>Status</h6>
                    <div class="active-switch">
                      <label class="switch">
                        <input type="checkbox" checked />
                        <span class="sliders round"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="mute-chat-btn">
            <a class="btn btn-primary" data-bs-dismiss="modal" :aria-label="$t('close')">
              Submit
            </a>
            <a class="btn btn-secondary" data-bs-dismiss="modal" :aria-label="$t('close')">
              Cancel
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Ban -->

  <!-- Add Ban -->
  <div class="modal fade" id="edit-ban-address">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit New Ban IP Address</h5>
          <button type="button" class="close" data-bs-dismiss="modal" :aria-label="$t('close')">
            <span class="material-icons">close</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="user-profiles-group mb-4">
            <form>
              <div class="row">
                <div class="col-md-12">
                  <div class="pass-login">
                    <label class="form-label">IP Address</label>
                    <input type="text" class="form-control" value="211.11.0.25" />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="pass-login">
                    <label class="form-label">Reason For Ban</label>

                    <editor v-model="content" />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="status-logs">
                    <h6>Status</h6>
                    <div class="active-switch">
                      <label class="switch">
                        <input type="checkbox" checked />
                        <span class="sliders round"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="mute-chat-btn">
            <a class="btn btn-primary" data-bs-dismiss="modal" :aria-label="$t('close')">
              Submit
            </a>
            <a class="btn btn-secondary" data-bs-dismiss="modal" :aria-label="$t('close')">
              Cancel
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Ban -->

  <!-- Delete User -->
  <div class="modal fade" id="delete-user">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Delete IP Address</h5>
          <button type="button" class="close" data-bs-dismiss="modal" :aria-label="$t('close')">
            <span class="material-icons">close</span>
          </button>
        </div>
        <div class="modal-body text-center">
          <div class="block-user-blk">
            <p>Deleting entire IP Address from this device</p>
          </div>
          <div class="mute-chat-btn justify-content-center">
            <a class="btn btn-primary" data-bs-dismiss="modal" :aria-label="$t('close')">
              Continue
            </a>
            <a class="btn btn-secondary" data-bs-dismiss="modal" :aria-label="$t('close')">
              Cancel
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete User -->
</template>
<script>
import Editor from "@tinymce/tinymce-vue";
export default {
  components: {
    editor: Editor,
  },
  data() {
    return {
      content: "Description",
    };
  },
};
</script>
